import BigNumber from 'bignumber.js'
import dayjs from 'dayjs'

import { fmtThousand } from './utils'

export function formatAddress(
  address: string = '',
  startChars: number = 4,
  endChars: number = -4,
  separator: string = '...'
) {
  return `${address.slice(0, startChars)}${separator}${endChars ? address.slice(endChars) : ''}`
}

export function formatCapitalize(str: string | undefined | null) {
  if (!str) {
    return ''
  } else {
    return str.replace(/\b\w/g, char => char.toUpperCase())
  }
}

export function formatDate(
  date: string | number,
  template: string = 'MM/DD/YYYY HH:mm:ss'
) {
  return dayjs(date).format(template)
}

export function formatNumber(
  number: BigNumber.Value,
  precision = 2,
  fmt = fmtThousand
): string {
  BigNumber.config({ FORMAT: fmt })
  return new BigNumber(number).toFormat(precision, 1) // ROUND_DOWN
}

// 限制输入正数
export function filterPositive(str: string, figure?: number): string {
  let ret = str
    .replace(/[^\d\.]/g, '')
    .replace(/\.(?=.*\.)/g, '')
    .replace(/^0\d+/g, '0')
    .replace(/^\.(\d*)$/, '0.$1')
  // .replace(/^(\d+)\.(\d*)$/,'$1.$2')
  // .replace(/^(\d+)\.(\d\d).*$/,'$1.$2')
  if (figure && figure > 0) {
    const exp = new RegExp(`^(\\d+)(\\.\\d{${figure}}).*$`)
    ret = ret.replace(exp, '$1$2')
  } else if (figure == 0) {
    const exp = new RegExp(`^(\\d+)\\..*$`)
    ret = ret.replace(exp, '$1')
  }
  return ret
}

/**
 * 格式化数字（保留2位小数，4位有效小数）
 * @param {number, string} num
 * @param {number} figure 保留小数位数
 * @param {number} dsn 有效小数位数
 * @param {boolean} thousand 格式化为千分位数
 * @param {string} holder 占位符
 * @returns {string}
 */
export function formatFixedNum(
  num: number | string,
  figure: number = 2,
  dsn: number = 4,
  thousand: boolean = false,
  holder: string = '--'
): string {
  let result;
  if (num == null) {
    result = holder;
  }
  else if (Math.abs(Number(num)) >= 1) {
    // 大于等于1
    let val: any = new BigNumber(num);
    val = figure == null ? val : val.dp(figure, BigNumber.ROUND_DOWN);
    val = thousand ? val.toFormat() : val.toFixed();
    result = val;
  }
  else if (Math.abs(Number(num)) >= 0) {
    // 小于1大于0
    if (dsn >= 1) {
      const n = dsn < 1 ? 0 : dsn - 1;
      const reg = new RegExp(`^.*\\.(0*[1-9][0-9]{0,${n}}).*$`);
      const float = (BigNumber(num).toFixed().match(reg) || [])[1]?.replace(/0*$/, '');
      result = float ? `${Number(num) < 0 ? '-' : ''}0.${float}` : '0';
    }
    else {
      result = '0';
    }
  }
  return result;
}

/**
 * 格式化为万千单位的数字（默认保留2位小数，4位有效小数）
 * @param {number, string} num
 * @param {number} figure 保留小数位数
 * @param {number} dsn 有效小数位数
 * @param {boolean} thousand 格式化为千分位数
 * @param {string} holder 占位符
 * @returns {string}
 */
export function formatUnitNum(
  num: number | string | undefined,
  figure: number = 2,
  dsn: number = 4,
  thousand: boolean = false,
  holder: string = '--'
): string {
  let result;
  if (num == undefined) {
    return holder
  }
  const levels = [
    { value: 1e9, limit: 1e9, symbol: "B" },
    { value: 1e6, limit: 1e6, symbol: "M" },
    { value: 1e3, limit: 1e3, symbol: "K" },
    { value: 1, limit: 1, symbol: "" },
  ];
  const level = levels.find(function (item) {
    return new BigNumber(num).gte(item.limit);
  });

  if (level) {
    // 大于等于1
    let val: any = new BigNumber(num).dividedBy(level.value);
    val = figure == null ? val : val.dp(figure, BigNumber.ROUND_DOWN);
    val = thousand ? val.toFormat() : val.toFixed();
    result = `${val}${level.symbol}`;
  }
  else if (num != null && Number(num) >= 0) {
    // // 小于1大于0
    // const float = (String(num).match(/^.*\.(0*[1-9][0-9]{0,3}).*$/) || [])[1]?.replace(/0*$/, '');
    // result = float ? `0.${float}` : '0';
    // 小于1大于0
    if (dsn >= 1) {
      const n = dsn < 1 ? 0 : dsn - 1;
      const reg = new RegExp(`^.*\\.(0*[1-9][0-9]{0,${n}}).*$`);
      const float = (String(num).match(reg) || [])[1]?.replace(/0*$/, '');
      result = float ? `0.${float}` : '0';
    }
    else {
      result = '0';
    }
  }
  else {
    result = holder;
  }
  return result;
}
